module.exports = __webpack_public_path__ + "img/marketpett_logo.215d2add.svg";